module.exports = __webpack_public_path__ + "e7998f1489b47048ce22f2d1c82f095b.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-picture.png
// module id = 3213
// module chunks = 69